import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ampImg from '../../static/images/AMP-icon-blue.svg';

export default class Phone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ampUrl: this.props.ampUrl ? (this.props.ampUrl + '#paddingTop=60') : null,
    };
  }

  render() {
    const ampUrl = this.state.ampUrl;
    let originalDomain = '';
    if (this.props.originalUrl) {
      originalDomain = (this.props.originalUrl.split('://')[1] || '').split('/')[0] || '';
    }
    return (
      <div className={!!ampUrl ? 'iphone8 with-iframe' : 'iphone8' }>
        <div className="top-bar"></div>
        <div className="sleep"></div>
        <div className="volume"></div>
        <div className="screen">
          {!!ampUrl &&
            <div className="iphone-header above">
              <div className="close">
                <span></span>
                <span></span>
              </div>
              <span className="url-name">{originalDomain}</span>
              <div className="right-content">
                <span className="chain"></span>
                <span className="dots"></span>
              </div>
            </div>
          }
          {!ampUrl ? (
          <div className="screen-empty">
            <div className="iphone-header">
              <div className="close">
                <span></span>
                <span></span>
              </div>
              <div className="right-content">
                <span className="chain"></span>
                <span className="dots"></span>
              </div>
            </div>
            <div className="img-spans">
              <img src={ampImg} alt="AMP-icon-blue"/>
              <div>
                <span></span>
                <i></i>
              </div>
            </div>
            <span className="grey-block"></span>
            <span className="grey-line"></span>
            <span className="grey-line"></span>
            <span className="grey-line-240"></span>
            <span className="grey-line-130"></span>
            <span className="grey-line-290"></span>
            <div className="buttons-block">
              <span></span>
              <span></span>
            </div>
          </div>
          ) : (
            <iframe ref='iframe' sandbox="allow-same-origin allow-scripts allow-forms" src={ampUrl} title="phone"></iframe>
          )}
        </div>
        <div className="home" onClick={this.reloadWindow.bind(this)}></div>
      </div>
    );
  }

  reloadWindow(event) {
    let iframeNode = ReactDOM.findDOMNode(this.refs.iframe);
    if (iframeNode) {
      iframeNode.src = this.state.ampUrl;
    }
    event.preventDefault();
  }

}



// WEBPACK FOOTER //
// ./src/components/phone/phone.js